import { logger as garnishLogger } from '@garnish/logger';

garnishLogger.enable('LAUNCH_DARKLY_INTEGRATION');

export const log = garnishLogger.extend('LAUNCH_DARKLY_INTEGRATION');
